<template>
    <div>
        <app-header></app-header>
        <div class="container">

            <!-- more like reviewable container, looping stops error before reviewable has loaded -->
            <div class="column"
                v-for="reviewable in reviewables"
                v-bind:key="reviewable.id"
            >
                <rev-card :reviewable="reviewable"></rev-card>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [GetAxiosAuthConfig],
        data() {
            return {
                // Set data property from the router (routes.js)
                id: this.$route.params.id,

                // Data properties for the den api
                reviewables : [],
            }
        },
        watch: {
            '$route'(to, from){
                // update id
                this.id = to.params.id
                
                // need to get that id!
                this.GetSingleReviewable()
            }
        },
        methods: {
            // similar to get reviewables
            GetSingleReviewable() {
                // Use the URL rather than the filter for ID
                let resturl = window.location.origin + '/api/reviewables/' + this.id + '/?format=json'

                axios
                    .get(resturl, axios_auth_config)
                    .then(response => (this.reviewables = [response.data])) // Does not return an array, so need to make it one
                    .catch(error => console.log(error))
            },
        },
        mounted() {
            this.GetSingleReviewable()
        },
    }
</script>

<style>
</style>
